precision highp float;

varying vec2 vUv;
uniform float uTime;
uniform float uHover;
uniform vec2  uResolution;
uniform float uAudioLevel;
uniform float uBass;
uniform float uMid;
uniform float uTreble;
uniform vec3  uObjectColor;
uniform vec3  uBgColor;
uniform int   uShapeIdx;
uniform int   uLineCount;
uniform float uScale;

float hash(vec2 p) {
    return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453);
}

float noise(vec2 p) {
    vec2 i = floor(p);
    vec2 f = fract(p);
    f = f * f * (3.0 - 2.0 * f);
    return mix(
        mix(hash(i),                 hash(i + vec2(1.0, 0.0)), f.x),
        mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), f.x),
        f.y
    );
}

// Returns distance from point p to the ring of radius r for the chosen shape
float getRingDist(vec2 p, float r) {
    if (uShapeIdx == 1) {
        // Square rings: Chebyshev distance
        return abs(max(abs(p.x), abs(p.y)) - r);
    }
    if (uShapeIdx == 2) {
        // Wave rings: 3-petal sinusoidal perturbation
        float a  = atan(p.y, p.x);
        float pr = r * (1.0 + 0.18 * sin(a * 3.0));
        return abs(length(p) - pr);
    }
    if (uShapeIdx == 3) {
        // Star rings: 5-point polar star
        float a  = atan(p.y, p.x);
        float pr = r * (0.82 + 0.18 * cos(5.0 * a));
        return abs(length(p) - pr);
    }
    // Circle (default)
    return abs(length(p) - r);
}

void main() {
    float ratio = uResolution.x / uResolution.y;
    vec2  uv    = vUv - 0.5;
    uv.x *= ratio;
    uv /= max(uScale, 0.01);

    float t      = uTime * 0.48;
    float breath = 0.4 + uBass * 0.6;
    float distort = noise(uv * 5.0 + t * 0.35) * 0.035;

    vec3 col = uBgColor;

    float rings  = 0.0;
    float maxR   = float(uLineCount);
    float outerR = 0.492; // keeps outer ring at same physical radius regardless of count

    for (int i = 0; i < 9; i++) {
        if (i >= uLineCount) break;
        float fi   = float(i + 1);
        float r    = fi * (outerR / maxR) + breath * 0.016 + distort;
        float d    = getRingDist(uv, r);
        float ring = smoothstep(0.007, 0.0, d);
        float fade = 1.0 - fi / (maxR + 1.0);
        rings += ring * max(fade, 0.0);
    }

    vec3 ringColor = mix(uObjectColor * 0.5, uObjectColor, breath);
    ringColor = mix(ringColor, min(uObjectColor + vec3(0.2), vec3(1.0)), uHover * 0.15);
    col += ringColor * rings;

    // Center dot
    col += min(uObjectColor + vec3(0.1), vec3(1.0)) *
           smoothstep(0.012, 0.0, length(uv) - 0.005 * (1.0 + breath * 0.6));

    // Vignette
    col *= 1.0 - smoothstep(0.28, 0.82, length(uv));
    col  = clamp(col, 0.0, 1.0);

    gl_FragColor = vec4(col, 1.0);
}
